<template>
  <div class="create-customer-drawer"
       v-if="drawer">
    <el-drawer :title="title"
               :visible.sync="drawer"
               :wrapperClosable="false"
               :close-on-press-escape="false"
               direction="rtl"
               @close="colseDrawer">
      <div class="base">
        <div class="add-item-title"
             style="margin-top: 0">基本信息</div>
        <el-form ref="form"
                 :inline="true"
                 :model="form"
                 :rules="rules"
                 label-width="80px"
                 size="mini"
                 v-enterToNext="true">
          <el-form-item label="简称"
                        prop="forShort">
            <el-input v-model="form.forShort"
                      maxlength="20"></el-input>
          </el-form-item>
          <!-- 
          <el-form-item label="合同开始"
                        prop="startTime">
            <el-date-picker v-model="form.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="全称"
                        prop="companyName">
            <el-input v-model="form.companyName"
                      maxlength="20"></el-input>
          </el-form-item>
          <!-- <el-form-item label="合同结束"
                        prop="endTime">
            <el-date-picker v-model="form.endTime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="手机号码"
                        prop="phone">
            <el-input v-model="form.phone"
                      maxlength="11"></el-input>
          </el-form-item>

          <el-form-item label="状态"
                        prop="isStop">
            <el-radio-group v-model="form.isStop">
              <el-radio :label="false">启用</el-radio>
              <el-radio :label="true">停用</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="地址"
                        prop="address">
            <el-input v-model="form.address"
                      maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="行业类别"
                        prop="industry">
            <el-select v-model="form.industry"
                       placeholder="请选择行业类别">
              <el-option v-for="item in industryList"
                         :key="item.Id||item.Value  "
                         :label="item.Description || item.description"
                         :value="item.Description || item.description">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="首页" prop="homePage">
            <el-input v-model="form.homePage" maxlength="50"></el-input>
          </el-form-item> -->
          <el-form-item label="联系人"
                        prop="linkman">
            <el-input v-model="form.linkman"
                      maxlength="20"></el-input>
          </el-form-item>

          <el-form-item label="邮箱">
            <el-input v-model="form.email"
                      maxlength="50"></el-input>
          </el-form-item>

          <el-col :span="24">
            <el-form-item label="排序">
              <el-input-number v-model="form.sort"
                               :precision="0"></el-input-number>
            </el-form-item>
          </el-col>
          <el-form-item label="对外发布"
                        class="form-item-block">
            <el-checkbox v-model="form.isRelease">是</el-checkbox><span class="tip"> （注：将同步在小程序和相应平台发布招聘信息）</span>
          </el-form-item>
          <div v-show="form.isRelease"
               class="foreign">
            <el-row>
              <el-form-item label="封面图"
                            prop="logo"
                            label-width="81px">
                <el-upload :class="{ 'factory-hide-upload': isHideLogoUpload }"
                           action=""
                           :limit="1"
                           accept=".jpg,.png"
                           :file-list="form.logo"
                           list-type="picture-card"
                           :on-exceed="onExceed"
                           :on-preview="onPreview"
                           :before-remove="removeUploadLogo"
                           ref="uploadComapnayLogo"
                           :http-request="uploadComapnayLogo">
                  <i class="el-icon-plus"></i>
                  <div slot="tip"
                       class="el-upload__tip">
                    请上传.jpg/.png格式文件，建议尺寸600*500px，文件大小不超过300kb
                  </div>
                </el-upload>
              </el-form-item>
            </el-row>
            <el-form-item label="类型">
              <el-select v-model="form.class"
                         placeholder="请选择类型">
                <el-option v-for="item in CompanyTypeList"
                           :key="item.Id || item.value"
                           :label="item.Description || item.description"
                           :value="item.Description || item.description">
                </el-option>
              </el-select>
              <!-- <el-input v-model="form.class" maxlength="50"></el-input> -->
            </el-form-item>
            <el-form-item label="统一社会信用代码"
                          label-width="135px"
                          class="code-input"
                          prop="creditCode">
              <el-input v-model="form.creditCode"
                        maxlength="50"></el-input>
            </el-form-item>

            <el-form-item label="简介"
                          class="form-item-block">
              <vue-ueditor-wrap v-if="form.desc"
                                v-model="form.desc"
                                :config="myConfig"></vue-ueditor-wrap>
              <el-input v-else
                        type="textarea"
                        :rows="4"
                        resize="none"
                        placeholder="请输入简介"
                        v-model="form.desc">
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="rightPadding"></div>

      <div class="submit-bar">
        <el-button @click="
            () => {
              colseDrawer();
            }
          ">取 消</el-button>
        <el-button type="primary"
                   :loading="submitLoading"
                   @click="onSubmit">保 存</el-button>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="imgDialog.show">
      <img width="100%"
           :src="imgDialog.url"
           alt="" />
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: {
    VueUeditorWrap,
  },
  props: {
    users: Array,
    title: String,
    drawerShow: Boolean,
    operation: String,
    customerInfo: Object,
    cityList: Array,
  },
  data () {
    let validatePhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!value) {
        callback();
      }
      if (!/^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    let validateHomePage = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      if (!/[-a-z0-9]+(\.[-a-z0-9]*\.(com|cn|edu|hk))/.test(value)) {
        callback(new Error("网站格式不正确，例子：www.eqlee.com"));
      } else {
        callback();
      }
    };
    let validatecreditCode = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!value) {
        callback();
      }
      if (
        !/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/.test(
          value
        )
      ) {
        callback(new Error("统一社会信用代码不正确"));
      } else {
        callback();
      }
    };
    return {
      myConfig: {
        // 设置编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 320,
        // 初始容器宽度
        initialFrameWidth: "100%",

        // UEditor 是文件的存放路径，
        UEDITOR_HOME_URL: "/Ueditor/",
      },
      submitLoading: false,
      drawer: false,
      companyScale: [],
      form: {
        license: [],
        logo: [],
        isStop: false,
        electronicProtocol: [],
      },
      imgDialog: {
        show: false,
        imgUrl: "",
      },
      currentUserInfo: null,
      rules: {
        companyName: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        homePage: [{ validator: validateHomePage, trigger: "blur" }],
        forShort: [{ required: true, message: "请输入简称", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        industry: [
          { required: true, message: "请选择行业类别", trigger: "blur" },
        ],
        creditCode: [{ validator: validatecreditCode, trigger: "blur" }],
        isStop: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["blur", "change"],
          },
        ],
      },
      personForm: {},
      manageInfoForm: {
        contractDate: [],
      },
      CompanyTypeList: [],
      industryList: [],
      invoiceForm: {},
      needInvoice: false,
      companyId: "00000000-0000-0000-0000-000000000000",
      receiver: {
        principal: [],
        own: [],
        other: [],
      },
      customenContacts: [],
    };
  },
  computed: {
    isHideLogoUpload: function () {
      return this.form.logo.length == 1;
    },
    isHideLicenseUpload: function () {
      return this.form.license.length == 1;
    },
  },
  created () {
    // this.getCompanyScaleData();
    // this.getUserInfo();
  },
  methods: {
    getEnumerationData () {
      this.$api.base.getEnumerationData("CompanyType").then((res) => {
        if (res.error === false || res.Error === false) {
          this.CompanyTypeList = res.data || res.Data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getindustryData () {
      this.$api.base.getEnumerationData("industry").then((res) => {
        if (res.error === false || res.Error === false) {
          this.industryList = res.data || res.Data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    validateForm (formName) {
      let isValidate = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          isValidate = true;
        } else {
          isValidate = false;
        }
      });
      return isValidate;
    },
    onSubmit () {
      if (!this.validateForm("form")) {
        this.$message.warning("填写信息有误，请检查表单");
        return;
      }
      if (this.needInvoice) {
        if (!this.validateForm("invoiceForm")) return;
      }
      this.submitLoading = true;
      var city = "";
      if (this.form.city) {
        this.form.city.forEach((item, i) => {
          city = city + item;
          if (i < this.form.city.length - 1) {
            city = city + ",";
          }
        });
      }
      let sendData = {
        customerName: this.form.companyName,
        forShort: this.form.forShort,
        customerAddress: this.form.address,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        contactNumber: this.form.phone,
        customerHomepage: this.form.homePage,
        creditCode: this.form.creditCode,
        email: this.form.email,
        theContact: this.form.linkman,
        customerType: this.form.class,
        customerDescribe: this.form.desc,
        customerLogo: this.form.logo[0]?.url || "",
        businessLicense: this.form.license[0]?.url || "",
        isStop: this.form.isStop,
        city: city,
        sort: this.form.sort ? this.form.sort : "",
        industry: this.form.industry,
        isRelease: this.form.isRelease
      };
      if (this.companyId != "00000000-0000-0000-0000-000000000000") {
        sendData.id = this.companyId;
      }

      this.$api.customer.addFactory(sendData).then((res) => {
        if (res.error === false) {
          this.$message.success("保存成功");
          this.$emit("refreshData");
        } else {
          this.$message.error("保存失败");
        }
        this.submitLoading = false;
        this.colseDrawer();
        this.companyId = "00000000-0000-0000-0000-000000000000";
      });
    },
    getReceiverList (data, type) {
      if (type == 0) {
        this.receiver.principal.push(data);
      } else if (type == 1) {
        this.receiver.own.push(data);
      } else {
        this.receiver.other.push(data);
      }
      this.customenContacts = [
        ...this.receiver.principal,
        ...this.receiver.own,
        ...this.receiver.other,
      ];
    },
    deleteReceiver (data, type) {
      if (type == 0) {
        const index = this.receiver.principal.indexOf(data);
        this.receiver.principal.splice(index, 1);
      } else if (type == 1) {
        const index = this.receiver.own.indexOf(data);
        this.receiver.own.splice(index, 1);
      } else {
        const index = this.receiver.other.indexOf(data);
        this.receiver.other.splice(index, 1);
      }
      this.customenContacts = [
        ...this.receiver.principal,
        ...this.receiver.own,
        ...this.receiver.other,
      ];
    },
    uploadLicense (fileObj) {
      this.uploadSingleImage(fileObj, "license");
    },
    uploadComapnayLogo (fileObj) {
      this.submitLoading = true;

      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$refs.uploadComapnayLogo.clearFiles();
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        this.submitLoading = false;

        return;
      }

      this.uploadSingleImage(fileObj, "logo");
    },
    uploadElectronicProtocol (fileObj) {
      const formData = new FormData();
      formData.append("file", fileObj.file);
      this.$api.upload.uploadFile(formData).then((res) => {
        if (res.code === 0) {
          this.form["electronicProtocol"].push({
            name: fileObj.file.name,
            url: res.data[0],
          });
        }
      });
    },
    uploadSingleImage (fileObj, imgType) {
      // const formData = new FormData();
      // formData.append("file", fileObj.file);
      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          this.submitLoading = false;

          if (res.code === 0) {
            this.form[imgType].push({
              name: fileObj.file.name,
              url: res.data[0],
            });
          }
        })
        .catch((error) => {
          this.submitLoading = false;

          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.form[imgType] = [];
          }
        });
    },
    onExceed (files, fileList) {
      this.$message.warning("只允许上传一张图片，请移除已上传图片后再进行操作");
    },
    onPreview (file) {
      console.log("dfsfd========s", file);
      this.imgDialog.show = true;
      this.imgDialog.url = file.url;
    },
    removeUploadLogo () {
      this.form.logo = [];
    },
    removeUploadLicense () {
      this.form.license = [];
    },
    removeUploadProtocol () {
      this.form.electronicProtocol = [];
    },
    colseDrawer () {
      this.$emit("colseDrawer");
    },
    setCustomenContacts (customerInfo) {
      customerInfo.customenContacts.forEach((v) => {
        if (v.IsPrimaryCustomen) {
          this.receiver.principal.push(v);
        } else if (v.IsOurCustomen) {
          this.receiver.own.push(v);
        } else {
          this.receiver.other.push(v);
        }
      });
    },
    fillFormData (customerInfo) {
      this.companyId = customerInfo.id;
      const PrincipalId =
        customerInfo.PrincipalId == "00000000-0000-0000-0000-000000000000"
          ? ""
          : customerInfo.PrincipalId;
      // 基本信息
      this.$set(this.form, "companyName", customerInfo.customerName);
      this.$set(this.form, "forShort", customerInfo.forShort);
      this.$set(this.form, "creditCode", customerInfo.creditCode);
      this.$set(this.form, "address", customerInfo.customerAddress);
      this.$set(
        this.form,
        "city",
        customerInfo.city && customerInfo.city.split(",")
      );
      this.$set(this.form, "industry", customerInfo.industry);
      this.$set(this.form, "companyLevel", customerInfo.customerLevel);
      this.$set(this.form, "endTime", customerInfo.endTime);
      this.$set(this.form, "homePage", customerInfo.customerHomepage);
      this.$set(this.form, "linkman", customerInfo.theContact);
      this.$set(this.form, "phone", customerInfo.contactNumber);
      this.$set(this.form, "weChat", customerInfo.weChatNumber);
      this.$set(this.form, "email", customerInfo.email);
      this.$set(this.form, "class", customerInfo.customerType);
      this.$set(this.form, "desc", customerInfo.customerDescribe);
      this.$set(this.form, "isStop", customerInfo.isStop);
      this.$set(this.form, "startTime", customerInfo.startTime);
      this.$set(this.form, "endTime", customerInfo.endTime);
      this.$set(this.form, "isRelease", customerInfo.isRelease);
      this.$set(
        this.form,
        "sort",
        customerInfo.sort == null ? undefined : customerInfo.sort
      );

      customerInfo.businessLicense &&
        this.form.license.push({
          name: "营业执照",
          url: customerInfo.businessLicense,
        });
      customerInfo.customerLogo &&
        this.form.logo.push({
          name: "企业LOGO",
          url: customerInfo.customerLogo,
        });
    },

    getUserInfo () {
      const memberId = JSON.parse(localStorage.getItem("Authorization"))
        ? JSON.parse(localStorage.getItem("Authorization")).memberId
        : "";
      if (!memberId) return;
      this.$api.user.getUserInfo(memberId).then((res) => {
        if (res.code === 0) {
          this.currentUserInfo = res.data;
        }
      });
    },
  },
  watch: {
    drawerShow (val) {

      if (val) {
        this.getEnumerationData();
        this.getindustryData();
        this.$nextTick(() => {
          this.$refs["form"].clearValidate();
        });
      }
      this.drawer = val;
      if (this.drawer == false) {
        this.companyId = "00000000-0000-0000-0000-000000000000";
        this.needInvoice = false;
        this.form = {
          license: [],
          logo: [],
          electronicProtocol: [],
        };
        this.manageInfoForm = {
          contractDate: [],
        };

        this.receiver = {
          principal: [],
          own: [],
          other: [],
        };
        return;
      }
      if (this.operation == "edit") {
        this.fillFormData(this.customerInfo);
        // this.setCustomenContacts(this.customerInfo);
      } else {
        // this.setInitReceiver();
      }
    },
  },
};
</script>

<style lang="less">
.create-customer-drawer {
  .el-drawer {
    width: 78% !important;
    .el-drawer__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 0;
      padding-bottom: 15px;
    }
    .el-drawer__body {
      // display: flex;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
  .factory-hide-upload {
    .el-upload--picture-card {
      display: none;
    }

    .el-upload__tip {
      margin-top: 0;
    }
    .el-upload-list--picture-card .el-upload-list__item {
      width: 170px !important;
      height: 146px !important;
    }
  }
  .add-item-title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  }
  .tip {
    font-size: 12px;
    color: #909399;
  }
  .base {
    width: 80%;
    float: left;
    padding: 17px 20px 60px 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fff;
    .el-form-item {
      width: 48%;
      .el-form-item__content {
        width: 54%;
      }
      .el-select {
        width: 100%;
      }
    }
    .foreign {
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #dcdfe6;
    }
    .code-input {
      .el-form-item__content {
        width: calc(54% - 55px);
      }
    }
    .form-item-block {
      width: 100%;
      .el-form-item__content {
        width: 90%;
      }
    }
  }
  .rightPadding {
    width: 20%;
    height: 100%;
    float: right;
    // background-color: rgba(0, 0, 0, 0.03);
  }
  .submit-bar {
    position: absolute;
    z-index: 99999;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 0;
    background-color: #fff;
    text-align: center !important;
    border-top: 1px solid #ddd;
    padding-right: 20px;
    .el-button {
      padding: 8px 20px;
    }
  }
}
</style>
